const KEY = 'dispence.preferredWalletId'

/** The wallet this browser trades from when the account has several (local to the browser). */
export function getPreferredWalletId(): string | null {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return null
  }
}

export function setPreferredWalletId(id: string | null) {
  try {
    if (id) localStorage.setItem(KEY, id)
    else localStorage.removeItem(KEY)
  } catch {
    // storage blocked: the default wallet stays in use
  }
}
